import React from 'react';
import { Checkbox, NumericInput, PropertyGrid } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import I18N from '@leverege/i18n';
import Model from "./GroupingsModel.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.dataViewers.googleMap.GroupingsEditor');
export default function GroupingsEditor(props) {
  const {
    value
  } = props;
  const onModelChange = useValueChange(Model, props);
  return /*#__PURE__*/_jsxs(PropertyGrid, {
    children: [/*#__PURE__*/_jsx(PropertyGrid.Item, {
      fillCell: true,
      children: /*#__PURE__*/_jsx(Checkbox, {
        label: t('visible'),
        eventData: "setVisible",
        value: Model.getVisible(value),
        onChange: onModelChange
      })
    }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
      label: t('opacity'),
      children: /*#__PURE__*/_jsx(NumericInput, {
        eventData: "setOpacity",
        value: Model.getOpacity(value),
        onChange: onModelChange
      })
    })]
  });
}